const tiposCredito = [
  { id: 'MSI', label: 'Meses Sin Intereses' },
  { id: 'MCI', label: 'Meses Con Intereses' },
];

export default tiposCredito;
